import styled from "@emotion/styled";
import { FlexRow, H2, HeadingGroup, Link, Stack } from "atoms";
import { HomePageDataShape } from "features/hub/api/useHomePageData";
import { ReviewableCard } from "features/reviewable";

type FeaturedTagProps = HomePageDataShape["discoverTagBlock"];

function FeaturedTagBlock({ tagName, tagURL, items }: FeaturedTagProps) {
  return (
    <section>
      <Stack gap="md">
        <FlexRow justifyContent="space-between" alignItems="flex-end">
          <HeadingGroup>
            <small>Hugworthy Spotlight</small>
            <H2>Discover {tagName}</H2>
          </HeadingGroup>

          <Link to={tagURL} size="xs" variant="secondary" arrow="r">
            View all {tagName}
          </Link>
        </FlexRow>

        <CardGrid>
          {items?.map((artist) => (
            <ReviewableCard {...artist} key={artist.id} />
          ))}
        </CardGrid>
      </Stack>
    </section>
  );
}

const CardGrid = styled.div(({ theme }) => ({
  display: "grid",
  gap: theme.spacing.gap,
  gridTemplateColumns: "repeat(2, 1fr)",
  [theme.breakpoints.desktop]: {
    gridTemplateColumns: "repeat(4, 1fr)",
  },
}));
export { FeaturedTagBlock };
